import { useEffect, useState } from 'react';

import { Delete } from '@ce-cfbdigital/cgl-cfb-fe-foundation';
import PubSub from 'pubsub-js';

import oktaAuth from '../../auth/oktaAuth';
import { IS_PRE_EXISTING_CART_CLEARED } from '../../constants';
import { logger } from '../../logger';
import { getAppConfig, getCachedUserInfo, getServiceConfig, handleLogout, updateSessionStorage } from '../../utilities';
import { Get } from '../../utilities/api-wrapper';
import { EXTERNAL_USER, INTERNAL_USER } from '../../utilities/constants';

const fetchCartAfterDeleteCart = isFromCartOrOBP => {
  if (isFromCartOrOBP) {
    PubSub.publish('fetchCartAfterDeleteCart');
  }
};

const useHeader = ({ pathname, hideCart }) => {
  // in case of abrupt closure of active tab:
  if (!updateSessionStorage.getItem(IS_PRE_EXISTING_CART_CLEARED)) {
    updateSessionStorage.setItem(IS_PRE_EXISTING_CART_CLEARED, false);
  }

  const isFromCartOrOBP = pathname.includes('cart') || pathname.includes('orderbuilder');

  const [isShowCart, setIsShowCart] = useState(null);
  const [userGroups, setUserGroups] = useState(null);
  const [cartItemCount, setCartItemCount] = useState(0);
  const [isDeleteCart, setIsDeleteCart] = useState(false);

  const updateCartCount = (_msg, count) => {
    setCartItemCount(count);
  };

  PubSub.subscribe('updateCartCountForHeader', updateCartCount);

  const fetchCart = async () => {
    const { url } = getServiceConfig('getCart');
    const countUrl = `${url}?itemCount=true`;
    Get(countUrl, true)
      .then(({ data }) => {
        updateSessionStorage.removeItem('cartItemsCount');
        if (pathname.includes('orders') && data.encCartid) {
          updateSessionStorage.setItem('cartItemsCount', data.encCartid);
        }
        setCartItemCount(data.cartCount || 0);
      })
      .catch(error => {
        setCartItemCount(0);
        logger.error('Error in getting fetchCart data', error);
      });
  };

  const clearPreExistingCart = async () => {
    const appConfig = getServiceConfig('clearCartAll');
    await Delete(appConfig, oktaAuth)
      .then(() => {
        updateSessionStorage.setItem(IS_PRE_EXISTING_CART_CLEARED, true);
        fetchCartAfterDeleteCart(isFromCartOrOBP);
      })
      .catch(err => {
        updateSessionStorage.setItem(IS_PRE_EXISTING_CART_CLEARED, false);
        logger.error('Error in clearing pre-existing cart', err);
      });
  };

  const getUserGroups = async () => {
    try {
      const {
        data: { groups }
      } = await getCachedUserInfo();
      const { internalUserGroup } = getAppConfig('oktaUserGroups');
      const purchasePermission = groups.includes('DXP_Food_AccGrp_Purchase_Products'.toLowerCase());
      if (groups.includes(internalUserGroup.toLowerCase())) {
        updateSessionStorage.setItem('user-type', INTERNAL_USER);
      } else {
        updateSessionStorage.setItem('user-type', EXTERNAL_USER);
      }
      if (purchasePermission) {
        setIsShowCart(purchasePermission);
        if (!updateSessionStorage.getItem(IS_PRE_EXISTING_CART_CLEARED)) {
          clearPreExistingCart();
        } else if (!hideCart) {
          fetchCart();
        }
      }
      setUserGroups(groups);
    } catch (error) {
      setUserGroups([]);
      logger.error('Error in getting user groups', error);
    }
  };

  const defaultCartItemCount = () => setCartItemCount(0);

  const handleLogoutInterface = () => {
    if (cartItemCount && !pathname.includes('confirmation')) {
      setIsDeleteCart(!isDeleteCart);
    } else {
      handleLogout();
    }
  };

  const handleDeleteModal = () => {
    setIsDeleteCart(false);
  };

  useEffect(() => {
    getUserGroups(); // Me API call
    if (!hideCart) {
      PubSub.subscribe('updateCart', fetchCart);
      PubSub.subscribe('defaultCartItemCount', defaultCartItemCount);
    }
  }, []);

  return { isShowCart, userGroups, cartItemCount, handleLogoutInterface, isDeleteCart, handleDeleteModal };
};

export default useHeader;
